import React from 'react'

import { Button } from '@components'
import { ReportPDF } from '@components/ReportPDF'
import { PDFDownloadLink } from '@react-pdf/renderer'
import { useGetRecurrentQuestionDetailsQuery } from '@services/reportApi'
import { adaptRecurrentDetailsToPDF } from '@utils/reportAdapter'
import { Printer, Loader2 } from 'lucide-react'

interface Props {
	disciplineId: string | number
	juryId: string | number
	yearId: string | number
	disciplineName: string
	juryName: string
	year: string
}

export function DownloadReportButton({
	disciplineId,
	juryId,
	yearId,
	disciplineName,
	juryName,
	year,
}: Props) {
	const {
		data: apiData,
		isLoading,
		isError,
	} = useGetRecurrentQuestionDetailsQuery(
		{
			disciplineId: Number(disciplineId),
			juryId: juryId ? Number(juryId) : undefined,
			yearId: yearId ? Number(yearId) : undefined,
		},
		{ skip: !disciplineId }
	)

	const generateFileName = () => {
		let fileName = `Relatório-${disciplineName}`

		if (juryName && juryName !== 'Todas as Bancas') {
			fileName += `-${juryName}`
		}

		if (year && year !== 'Todos os Anos') {
			fileName += `-${year}`
		}

		return `${fileName}.pdf`.replace(/\s+/g, '_')
	}

	if (isLoading) {
		return (
			<Button
				disabled
				className='gap-2 bg-gray-400 text-white px-3 py-1 text-xs'
			>
				<Loader2 className='w-4 h-4 animate-spin' />
				Carregando PDF...
			</Button>
		)
	}

	if (isError || !apiData) {
		return null
	}

	const pdfData = adaptRecurrentDetailsToPDF(apiData, disciplineName, juryName)

	return (
		<PDFDownloadLink
			document={<ReportPDF data={pdfData} />}
			fileName={generateFileName()}
		>
			{({ loading }) => (
				<Button
					disabled={loading}
					className='gap-2 bg-primary-light hover:bg-[#5aa8c7] text-white px-3 py-1 rounded text-xs flex items-center transition-colors'
				>
					<Printer className='w-4 h-4' />
					{loading ? 'Gerando...' : 'Baixar PDF'}
				</Button>
			)}
		</PDFDownloadLink>
	)
}
